import request from "../utils/request";

export async function getAllUserWantCategories() {
  return request.get("UserWantCategory");
}

export async function addUserWantCategory(userWantCategoryDto) {
  return request.post("UserWantCategory", userWantCategoryDto);
}

export async function updateUserWantCategory(userWantCategoryDto) {
  return request.put("UserWantCategory", userWantCategoryDto);
}

export async function deleteUserWantCategory(id) {
  return request.delete(`UserWantCategory/${id}`);
}
